const getUrl = () => {
  const env = process.env.REACT_APP_API;
  let currentDomain = 'nmd.co'; // Default to nmd.co

  try {
    const fullDomain = new URL(window.location.href).hostname;
    if (fullDomain.includes('named.com')) {
      currentDomain = 'named.com';
    } else if (fullDomain.includes('xn--950bo4em5v.co')) {
      currentDomain = 'xn--950bo4em5v.co';
    } else if (fullDomain.includes('named.net')) {
      currentDomain = 'named.net';
    } else if (fullDomain.includes('named2.net')) {
      currentDomain = 'named2.net';
    } else if (fullDomain.includes('named2.kr')) {
      currentDomain = 'named2.kr';
    }
  } catch (error) {
    console.error("Can't get current domain:", error);
  }

  let sports = 'http://172.16.20.93:8090/v1.0';
  let named = 'http://jspark.challenger-api.named.com/';
  let namedApi = 'http://mschoo.named.com/';
  let legacySports = 'http://172.16.20.93:8092/named/v1';
  let thumb = 'https://thumb.named.com/normal/resize';
  let thumbCrop = 'https://thumb.named.com/normal/crop';
  let webSocket = 'ws://172.16.20.96:8880/sub';
  let sportsWebURL = 'http://dev.score.named.com/';
  let casterWebURL = 'http://dev.caster.named.com/';
  let legacyApiKey = 'vYXBNAxjFCre';
  let image = 'https://image.named.com/';

  let champ = 'https://arowana-api.champscore.com/';
  let champThumb = 'https://thumb.champscore.com';
  let champWebSocket = 'wss://push.champscore.com/sub';

  let contactUsLink = 'https://sports.nmd.co/contact-us';

  let admin_ip = [
    '89.117.205.11', // Operation Team Lia

    '220.85.141.', //old
    '210.245.49.', //Arctx (Vietnam-dev)
    '210.245.48.132', //Arctx (Vietnam-marketing)
    '49.238.128.', //ARCTX (Armenia)
    '110.93.164.244', // VPN for Named dev team

    '54.180.245.50', // Operation team remote VM

    // Operation team VPN
    '122.99.161.182',
    '106.10.125.116',
    '106.10.117.51',
    '178.160.199.158',

    '13.125.243.26',
    '3.35.173.67',
    '31.220.9.148',

    // Clean IP VPN
    '49.238.128.163',
    '49.236.191.130',
    '59.150.56.105',
    '203.216.179.152',
    '49.238.132.214',
  ];

  switch (env) {
    case 'development':
      sports = 'http://52.78.195.200:8090/v1.0';
      named = `http://dev.challenger-api.${currentDomain}/`;
      namedApi = `http://dev.${currentDomain}/`;
      legacySports = 'http://52.78.195.200:8092/named/v1';
      webSocket = 'ws://52.78.195.200:8880/sub';
      sportsWebURL = `http://dev-score.${currentDomain}/`;
      casterWebURL = `http://dev-caster.${currentDomain}/`;
      legacyApiKey = 'vYXBNAxjFCre';
      image = `https://image.${currentDomain}/`;
      thumb = 'http://52.78.195.200:22010/normal/resize';
      thumbCrop = 'http://52.78.195.200:22010/normal/crop';

      //    TODO 아래는 챔프 세팅하고 변경
      champ = 'http://dev-arowana.champscore.com/';
      champThumb = 'http://dev-thumb.champscore.com';
      champWebSocket = 'ws://13.125.26.32:8880/sub';
      contactUsLink = `http://dev-sports.${currentDomain}/contact-us`;
      break;

    case 'local':
      sports = 'http://52.78.195.200:8090/v1.0';
      named = 'http://dev.challenger-api.named.com/';
      namedApi = 'http://dev.named.com/';
      legacySports = 'http://52.78.195.200:8092/named/v1';
      webSocket = 'ws://52.78.195.200:8880/sub';
      sportsWebURL = 'http://dev-score.named.com/';
      casterWebURL = 'http://dev-caster.named.com/';
      legacyApiKey = 'vYXBNAxjFCre';
      image = 'https://image.named.com/';
      thumb = 'http://52.78.195.200:22010/normal/resize';
      thumbCrop = 'http://52.78.195.200:22010/normal/crop';

      //    TODO 아래는 챔프 세팅하고 변경
      champ = 'http://dev-arowana.champscore.com/';
      champThumb = 'http://dev-thumb.champscore.com';
      champWebSocket = 'ws://13.125.26.32:8880/sub';
      contactUsLink = `http://dev-sports.${currentDomain}/contact-us`;
      break;

    case 'beta':
      sports = 'http://172.16.20.163:8080/v1.0';
      named = 'https://challenger-api.named.com/';
      namedApi = 'https://named.com/';
      legacySports = 'http://172.16.20.164:8092/named/v1';
      webSocket = 'ws://172.16.20.166:8880/sub';
      sportsWebURL = 'http://beta.score.named.com/';
      casterWebURL = 'http://beta.caster.named.com/';
      legacyApiKey = '8HNjAFFfmQoJ';
      image = 'https://image.named.com/';
      champ = 'http://mschoo.arowana-api.fishtank.com/';
      champThumb = 'http://dev-thumb.champscore.com';
      champWebSocket = 'ws://172.16.20.103:8880/sub';
      contactUsLink = `https://sports.${currentDomain}/contact-us`;
      break;

    case 'production':
      sports = `https://sports-api.${currentDomain}/v1.0`;
      named = `https://challenger-api.${currentDomain}/`;
      namedApi = `https://${currentDomain}/`;
      legacySports = `https://score-api.${currentDomain}/named/v1`;
      webSocket = `wss://push.${currentDomain}/sub`;
      sportsWebURL = `http://score.${currentDomain}/`;
      casterWebURL = `http://sports-caster.${currentDomain}/`;
      legacyApiKey = '1rar2zCZvKjp';
      image = `https://image.${currentDomain}/`;
      thumb = `https://thumb.${currentDomain}/normal/resize`;
      thumbCrop = `https://thumb.${currentDomain}/normal/crop`;
      contactUsLink = `https://sports.${currentDomain}/contact-us`;
      break;

    default:
      break;
  }

  return {
    sports,
    named,
    namedApi,
    legacySports,
    thumb,
    thumbCrop,
    webSocket,
    sportsWebURL,
    casterWebURL,
    legacyApiKey,
    image,
    champ,
    champThumb,
    champWebSocket,
    admin_ip,
    currentDomain,
    contactUsLink,
  };
};

const Url = getUrl();

export default Url;
